import compose from 'recompose/compose';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import { getPrismicProductByLocale, getPrismicProduct } from '../../store/selectors/prismic/product';
import { fetchPrismicProduct } from '../../store/thunks/prismic/product';

const withPrismicProduct = requiredKeys => compose(
  connect(
    (state, props) => ({
      fallbackProduct: pick(
        getPrismicProductByLocale(
          state,
          props.productId,
          props.country.localeCode,
        ),
        ['response', ...requiredKeys],
      ),
      product: pick(
        getPrismicProductByLocale(
          state,
          props.productId,
          props.productLocale,
        ),
        ['response', ...requiredKeys],
      ),
      prismicProductLangs: getPrismicProduct(
        state,
        props.productId
      ),
    }),
    null
  ),
  connect(
    null,
    (dispatch, props) => ({
      getPrismicProduct: (sku, locale) =>
        dispatch(fetchPrismicProduct(sku, locale, props)),
    }),
  ),
);

export default withPrismicProduct;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withPrismicProduct.js